import { render, staticRenderFns } from "./EmailConfirmationView.vue?vue&type=template&id=3ddb2c73&"
import script from "./EmailConfirmationView.vue?vue&type=script&lang=ts&"
export * from "./EmailConfirmationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports